export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBGMdXtT6fGDXxRUc3nYeD83h8gCTJCAhM",
    authDomain: "virtual-pujasweb.firebaseapp.com",
    projectId: "virtual-pujasweb",
    storageBucket: "virtual-pujasweb.appspot.com",
    messagingSenderId: "717470867996",
    appId: "1:717470867996:web:b2160c79e113bbff0cb5d9",
    measurementId: "G-XS3521XQFX",
  },
  firebaseEmulator: {
    enabled: false,
    auth: {
      host: 'localhost',
      port: 5003,
    },
    firestore: {
      host: 'localhost',
      port: 5001,
    },
    storage: {
      host: 'localhost',
      port: 5002,
    },
    functions: {
      host: 'localhost',
      port: 5005,
    },
  },
  backend: {
    url: "https://virtual-admin.pujasweb.co/api",
    widget: "https://virtual.pujasweb.co/api",
  },
  openWeatherApiKey: '347cc121b608fa9f543bda56640226a0',
};
